export const REDIRECTES = [
  {
    source: '/products/106/182-m2-fasadestillas-på-henger',
    destination: '/products/fasadestillas-182-m²-på-tilhenger-114',
    permanent: true,
  },

  {
    source: '/products/181/giraffsliper-med-støvsuger',
    destination: '/products/giraffsliper-med-støvsuger-30',
    permanent: true,
  },

  {
    source: '/products/166/stor-skaphenger',
    destination: '/products/skaphenger%2C-stor-12',
    permanent: true,
  },

  {
    source: '/products/142/ozon-maskin',
    destination: '/products/ozonmaskin%2Fluktfjerner-119',
    permanent: true,
  },

  {
    source: '/products/140/biltransporthenger',
    destination: '/products/biltransporthenger-m%2Fvinsj-15',
    permanent: true,
  },

  {
    source: '/products/161/trappetralle',
    destination: '/products/trappetralle-38',
    permanent: true,
  },

  {
    source: '/products/178/trillebår-i-kunststoff',
    destination: '/products/trillebår-i-kunststoff-50',
    permanent: true,
  },

  {
    source: '/products/120/skaphenger',
    destination: '/products/skaphenger%2C-medium-11',
    permanent: true,
  },

  {
    source: '/products/149/høytrykksvasker-medium',
    destination: '/products/høytrykkspyler%2C-medium-66',
    permanent: true,
  },

  {
    source: '/products/153/hekksaks',
    destination: '/products/hekksaks-41',
    permanent: true,
  },

  {
    source: '/products/150/høytrykk-liten',
    destination: '/products/høytrykkspyler%2C-liten-64',
    permanent: true,
  },

  {
    source: '/products/141/kvistkvern',
    destination: '/products/kvistkvern-116',
    permanent: true,
  },

  {
    source: '/products/208/våt-tørr-støvsuger',
    destination: '/products/tørr-%2Fvåtsugere-34',
    permanent: true,
  },

  {
    source: '/products/154/bæresystem-til-håndverktøy',
    destination: '/products/bæresystem-til-håndverktøy-39',
    permanent: true,
  },

  {
    source: '/products/134/10-5-meter-lift',
    destination: '/products/lift-10%2C5-m-21',
    permanent: true,
  },

  {
    source: '/products/171/dekkskiftpakke',
    destination: '/products/dekkskiftpakke-28',
    permanent: true,
  },

  {
    source: '/products/148/jordbor',
    destination: '/products/jordbor-103',
    permanent: true,
  },

  {
    source: '/products/191/steinsaks',
    destination: '/products/steinsaks-47',
    permanent: true,
  },

  {
    source: '/products/145/båthenger-25-fot',
    destination: '/products/båthenger-25-fot-16',
    permanent: true,
  },

  {
    source: '/products/164/slagbormaskin',
    destination: '/products/slagbormaskin-35',
    permanent: true,
  },

  {
    source: '/products/192/hagerake-fugeskrape-og-kultivator',
    destination: '/products/hagerake%2Fjernrake%2Ffugeskrape-og-kultivator-40',
    permanent: true,
  },

  {
    source: '/products/146/sammenleggbart-rullestillas',
    destination: '/products/rullestillas%2C-sammenleggbart-13',
    permanent: true,
  },

  {
    source: '/products/136/drill-leieprodukt',
    destination: '/products/drill%2C-hitachi-18-v-112',
    permanent: true,
  },

  {
    source: '/products/133/gipsheis-med-tilt',
    destination: '/products/gipsheis-115',
    permanent: true,
  },

  {
    source: '/products/144/luftkompressor',
    destination: '/products/luftkompressor-68',
    permanent: true,
  },

  {
    source: '/products/172/poleringsmaskin',
    destination: '/products/poleringsmaskin-6',
    permanent: true,
  },

  {
    source: '/products/119/grindhenger',
    destination: '/products/grindhenger%2C-medium-110',
    permanent: true,
  },

  {
    source: '/products/131/rullestillas-6-2-meter-høyde',
    destination: '/products/rullestillas-6%2C2-m-14',
    permanent: true,
  },

  {
    source: '/products/128/12meter-lift',
    destination: '/products/lift-12-m-22',
    permanent: true,
  },

  {
    source: '/products/170/dino-21m-lift',
    destination: '/products/lift-21-m-58',
    permanent: true,
  },

  {
    source: '/products/179/bæresele',
    destination: '/products/bæresele-36',
    permanent: true,
  },

  {
    source: '/products/173/hagerulle-vannfylt',
    destination: '/hagerulle%2C-vannfylt-10',
    permanent: true,
  },

  {
    source: '/products/143/stor-grindhenger',
    destination: '/products/grindhenger%2C-stor-17',
    permanent: true,
  },

  {
    source: '/products/162/kapp-og-gjerdesag-m-bord',
    destination: '/kapp--og-gjærsag-med-uttrekk-31',
    permanent: true,
  },

  {
    source: '/products/180/dolleystropper',
    destination: '/products/bærestropper-37',
    permanent: true,
  },

  {
    source: '/products/165/vedkløyver-16-tonn',
    destination: '/products/vedkløyver%2C-16-tonn-52',
    permanent: true,
  },

  {
    source: '/products/189/elektrisk-borhammer',
    destination: '/products/borhammer%2C-elektrisk-63',
    permanent: true,
  },

  {
    source: '/products/169/minigraver',
    destination: '/products/minigraver-1t-46',
    permanent: true,
  },

  {
    source: '/products/118/varehenger-m-tipp',
    destination: '/products/varehenger-med-tipp-5',
    permanent: true,
  },

  {
    source: '/products/138/dampvasker',
    destination: '/products/dampvasker-27',
    permanent: true,
  },

  {
    source: '/products/182/bordsag-til-stein-flissag',
    destination: '/products/bordsag-til-stein-og-flis-62',
    permanent: true,
  },

  {
    source: '/products/183/11kg-borhammer',
    destination: '/products/borhammer%2C-11-kg-59',
    permanent: true,
  },

  {
    source: '/products/184/18kg-rivningshammer',
    destination: '/products/rivningshammer%2C-18-kg-60',
    permanent: true,
  },

  {
    source: '/products/155/vibroplate-f75-23',
    destination: '/products/vibroplate-54',
    permanent: true,
  },

  {
    source: '/products/175/trolla-spreder',
    destination: '/products/trolla-spreder-51',
    permanent: true,
  },

  {
    source: '/products/121/88-m2-fasadestillas-på-henger',
    destination: '/products/fasadestillas-88-m²-på-tilhenger-3',
    permanent: true,
  },

  {
    source: '/products/194/skrumaskin',
    destination: '/products/skrumaskin-til-gulv%2C-automatisk-9',
    permanent: true,
  },

  {
    source: '/products/151/løvblåser-medium',
    destination: '/products/løvblåser%2C-medium-45',
    permanent: true,
  },

  {
    source: '/products/220/kombihammer',
    destination: '/products/borhammer%2C-elektrisk-63',
    permanent: true,
  },

  {
    source: '/products/157/betongblander-180liter',
    destination: '/products/betongblander-180-l-7',
    permanent: true,
  },

  {
    source: '/products/176/jordfreser',
    destination: '/products/jordfreser-43',
    permanent: true,
  },

  {
    source: '/products/177/stolpehammer-manuel',
    destination: '/products/stolpehammer%2C-manuel-48',
    permanent: true,
  },

  {
    source: '/products/168/stubbefreser',
    destination: '/products/stubbefreser-49',
    permanent: true,
  },

  {
    source: '/products/158/vedklyver-8-tonn',
    destination: '/products/vedklyver%2C-8-tonn-53',
    permanent: true,
  },

  {
    source: '/products/159/tørr-våt-støvsuger',
    destination: '/products/tørr-%2Fvåtsugere-34',
    permanent: true,
  },

  {
    source: '/products/186/bordsag',
    destination: '/products/bordsag-29',
    permanent: true,
  },

  {
    source: '/products/197/stendersøker',
    destination: '/products/stendersøker-33',
    permanent: true,
  },

  {
    source: '/products/207/stikksag-18v-batteri',
    destination: '/products/stikksag-105',
    permanent: true,
  },

  {
    source: '/products/199/tapetfjerner',
    destination: '/products/tapetfjerner-69',
    permanent: true,
  },

  {
    source: '/blog/hvordan-montere-stillas',
    destination: '/articles/hvordan-montere-stillas-6',
    permanent: true,
  },

  {
    source: '/blog/viktig-%C3%A5-tenke-p%C3%A5-n%C3%A5r-du-skal-leie-henger',
    destination: '/articles/viktig-å-tenke-på-når-du-skal-velge-tilhenger-8',
    permanent: true,
  },
]
